/**
 * @param {*} value
 * @return {value is String}
 */
export function isString(value) {
  return typeof value === 'string';
}
